<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row">
            <vx-card title="최근 활동 중인 클래스">
                <spaceItem/>
            </vx-card>
        </div> <p/>
        <div class="vx-row">
            <vx-card title="최근 활동 중인 클래스">
                <spaceItem/>
            </vx-card>
        </div>
        <div class="vx-row">
            <vx-card title="최근 활동 중인 클래스">
                <spaceItem/>
            </vx-card>
        </div>
        <!-- CHAT CARD -->
        <div>
            <component :is="scrollbarTag" ref="chatLogPS" class="scroll-area pt-6 px-6" :settings="settings" :key="$vs.rtl"/>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { videoPlayer }     from 'vue-video-player'
import VxTimeline          from "@/components/timeline/VxTimeline.vue"
import SpaceItem           from "@/views/apps/space/SpaceItem.vue"
import 'video.js/dist/video-js.css'



export default{
    components: {
        'spaceItem': SpaceItem,
        VuePerfectScrollbar,
        videoPlayer,
        VxTimeline
    },
    data() {
        return {
            chatMsgInput: '',
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    computed: {
      scrollbarTag() { return this.$store.getters.scrollbarTag },
    },
    mounted() {
        const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
        scroll_el.scrollTop = 0
    },
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
